import { useEffect, useState } from "react";
import { LoginPage, loadCurrentUser, type User } from "../features/auth";
import { AlertsPage } from "../features/alerts";
import { CamerasPage } from "../features/cameras";
import { DashboardPage } from "../features/dashboard";
import { EventsPage } from "../features/events";
import { SettingsPage } from "../features/settings";
import { WorkflowPage } from "../features/workflow";
import { AppShell } from "../layouts/AppShell";

export function AppRouter() {
  const [user, setUser] = useState<User | null>(null);
  const [authChecked, setAuthChecked] = useState(false);
  const path = window.location.pathname;

  useEffect(() => {
    loadCurrentUser()
      .then(setUser)
      .catch(() => setUser(null))
      .finally(() => setAuthChecked(true));
  }, []);

  if (!authChecked) {
    return <main className="auth-page" />;
  }
  if (!user) {
    return <LoginPage onLogin={setUser} />;
  }
  return (
    <AppShell user={user}>
      {path === "/alerts" ? (
        <AlertsPage />
      ) : path === "/cameras" ? (
        <CamerasPage />
      ) : path === "/events" ? (
        <EventsPage />
      ) : path === "/workflow" ? (
        <WorkflowPage />
      ) : path.startsWith("/settings") ? (
        <SettingsPage
          section={
            path === "/settings/security"
              ? "security"
              : path === "/settings/activity"
                ? "activity"
              : "settings"
          }
          user={user}
        />
      ) : (
        <DashboardPage />
      )}
    </AppShell>
  );
}
